
 import PricingButton from "@/components/main/pricing/PricingButton";
 import RedHeadBox from "@/components/main/core/RedHeadBox";
 import PricingQuestion from "@/components/main/core/PricingQuestion";
 export default {
   name: "CamStreamsTab",
   components: { PricingButton, RedHeadBox, PricingQuestion }
 }
 